import { c as _c } from "react/compiler-runtime";
import { ThumbnailImage } from "@components/common/thumbnail-image";
import { ListItemText } from "@flat-ui";
import { companyMemberGroupProjectByIdSelector } from "@store/company-member-groups/company-member-groups-selector";
import { getProjectByIdSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { defaultProjectThumbnail } from "@utils/project-utils";
/** List item in bulk action dialog for projects */
export function ProjectListContent(t0) {
  const $ = _c(12);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item.id) {
    t1 = getProjectByIdSelector(item.id);
    $[0] = item.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedProject = useAppSelector(t1);
  let t2;
  if ($[2] !== item.id) {
    t2 = companyMemberGroupProjectByIdSelector(item.id);
    $[2] = item.id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const memberGroupProject = useAppSelector(t2);
  const projectName = selectedProject?.name ?? memberGroupProject?.name;
  const projectThumbnail = selectedProject?.thumbnailUrl || memberGroupProject?.imageUrl;
  if (!projectName) {
    return null;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      height: "40px",
      width: "56px",
      maxHeight: "100%",
      maxWidth: "100%",
      objectFit: "contain",
      borderRadius: "8px"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== projectThumbnail) {
    t4 = <ThumbnailImage src={projectThumbnail} fallbackSrc={defaultProjectThumbnail} alt="Project thumbnail" sx={t3} />;
    $[5] = projectThumbnail;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== projectName) {
    t5 = <ListItemText primary={<var>{projectName}</var>} />;
    $[7] = projectName;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}